// The API serializes typed errors in two shapes: control()-wrapped routes
// send the code as a bare JSON string body ("DomainNotAllowed"), while
// older handlers send { error: "DomainNotAllowed" }. Read the code from
// either — matching on err.response.data.error alone silently misses every
// control()-wrapped route (all of /rmn/*).
export const apiErrorCode = (err: any): string | undefined => {
  const data = err?.response?.data
  if (typeof data === 'string' && data) return data
  const code = data?.error
  return typeof code === 'string' && code ? code : undefined
}
